import { render, staticRenderFns } from "./Triangle1Footer.vue?vue&type=template&id=b49ad0dc&"
import script from "./Triangle1Footer.vue?vue&type=script&lang=js&"
export * from "./Triangle1Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports